import { CheckCircle2 } from "lucide-react";

/** Styled checklist (checklist_page) — renders checklist_items as a scannable list. */
export function ChecklistBlock({ items, title = "The checklist" }) {
  if (!items?.length) return null;
  return (
    <section className="my-10 rounded-2xl border border-slate-200 bg-white p-6" data-testid="resource-checklist">
      <h2 className="font-heading text-xl font-semibold text-navy">{title}</h2>
      <ul className="mt-4 space-y-3">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 rounded-lg border border-slate-100 bg-background px-4 py-3 text-sm text-slate-700">
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-editorial" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

/** Key feature grid (tool / calculator pages). */
export function KeyFeatures({ features, title = "What you get" }) {
  if (!features?.length) return null;
  return (
    <section className="my-10" data-testid="resource-key-features">
      <h2 className="font-heading text-xl font-semibold text-navy">{title}</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {features.map((f, i) => (
          <div key={i} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4">
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-editorial" />
            <span className="text-sm leading-relaxed text-slate-700">{f}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
